import React from "react";
import StaticContentPage from "./StaticContentPage";
import { termsofUseText } from "../data/termsofUseContent";

const TermsofUse = () => {
  return (
    <StaticContentPage
      title="Terms of Service"
      seoTitle="Terms of Service | Eveness"
      seoDescription="Read the Eveness terms of service, including website usage rules, account terms, purchases, responsibilities, and legal conditions."
      canonicalPath="/policies/terms-of-service"
    >
      {termsofUseText}
    </StaticContentPage>
  );
};

export default TermsofUse;